import { render } from "./igSVG.vue?vue&type=template&id=5c467c19"
import script from "./igSVG.vue?vue&type=script&lang=js"
export * from "./igSVG.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__